// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab__wrapper {
  display: inline-flex;
  flex-direction: row;
  height: 48px;
  box-sizing: border-box;
}

.tab__wrapper.active {
  color: #000;
  font-weight: 500;
  border-bottom: 2px solid #000;
}

.tab__button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding-left: 16px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s ease;
}

.tab__button-label {
  font-family:
    "ABCFavorit",
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  white-space: nowrap; /* Prevent text wrapping */
}

.tab:hover {
  color: #4a5568;
}

.tab__icon {
  display: flex;
  align-items: center;
  margin-right: 8px;
}

.tab__edit-indicator {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 16px;
  padding-left: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Tab/tab.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE;;;;cAIY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB,EAAE,0BAA0B;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB","sourcesContent":[".tab__wrapper {\n  display: inline-flex;\n  flex-direction: row;\n  height: 48px;\n  box-sizing: border-box;\n}\n\n.tab__wrapper.active {\n  color: #000;\n  font-weight: 500;\n  border-bottom: 2px solid #000;\n}\n\n.tab__button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  padding-left: 16px;\n  font-weight: 400;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.tab__button-label {\n  font-family:\n    \"ABCFavorit\",\n    -apple-system,\n    BlinkMacSystemFont,\n    sans-serif;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  white-space: nowrap; /* Prevent text wrapping */\n}\n\n.tab:hover {\n  color: #4a5568;\n}\n\n.tab__icon {\n  display: flex;\n  align-items: center;\n  margin-right: 8px;\n}\n\n.tab__edit-indicator {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-right: 16px;\n  padding-left: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
